import { Button, Divider, Modal, Paper, Typography } from "@material-ui/core";
import React from "react";
import Loadable from "@loadable/component";
import { fontsName } from "../../assets/fonts/fontsName";
const OwlCarousel = Loadable(() => import("react-owl-carousel3"));

const optionsTwo = {
  loop: true,
  nav: false,
  dots: true,
  autoplayHoverPause: true,
  autoplay: true,
  margin: 10,
  navText: [
    "<i class='flaticon-left-1'></i>",
    "<i class='flaticon-right-1'></i>",
  ],
  responsive: {
    0: {
      items: 1,
    },
    768: {
      items: 1,
    },
    992: {
      items: 1,
    },
  },
};

const FeatureModal = ({ open, onClose, fact }) => {
  const [display, setDisplay] = React.useState(false);

  React.useEffect(() => {
    setDisplay(true);
  }, []);

  return (
    <>
      <Modal open={open} onClose={onClose} style={{ overflow: "scroll" }}>
        <Paper
          className="facility-modal-container"
        //   style={{
        //     width: "35%",
        //     margin: "50px auto",
        //     borderRadius: "15px",
        //     display: "flex",
        //     flexDirection: "column",
        //     alignItems: "center",
        //     justifyContent: "center",
        //   }}
        >
          <div
            style={{
              width: "100%",
              textAlign: "center",
              margin: "0px auto",
              marginTop: "30px",
              marginBottom: "15px",
            }}
          >
            {display ? (
              <OwlCarousel
                className="testimonials-slides  owl-carousel owl-theme"
                {...optionsTwo}
              >
                {fact && fact.pictureLink.length > 0
                  ? fact.pictureLink.map((pic, index) => (
                    <div
                      key={index}
                      style={{
                        width: "80%",
                        textAlign: "center",
                        margin: "8px auto",
                        border: "1px solid #130f40",
                        padding: "8px",
                        borderRadius: "10px",
                        //   height: "20vh",
                      }}
                    >
                      <div
                        style={{
                          borderRadius: "15px",
                          width: "100%",
                          height: "100%",
                          textAlign: "center",
                        }}
                      >
                        <img
                          src={pic}
                          alt="best-student"
                          style={{
                            width: "100%",
                            borderRadius: "10px",
                            textAlign: "center",
                          }}
                        />
                      </div>
                    </div>
                  ))
                  : ""}
              </OwlCarousel>
            ) : (
              ""
            )}
            <div
              style={{
                width: "80%",
                backgroundColor: "#dff9fb",
                borderRadius: "10px",
                padding: "20px 20px",
                margin: "15px auto",
              }}
            >
              <Typography
                gutterBottom
                style={{
                  fontFamily: fontsName.VazirBold,
                  color: "#4834d4",
                  fontSize: "18px",
                  textAlign: "right",
                }}
              >
                {fact.title}
              </Typography>
              <Divider />
              <Typography
                variant="body1"
                style={{
                  fontFamily: fontsName.VazirBold,
                  color: "#4834d4",
                  fontSize: "16px",
                  textAlign: "right",
                  marginTop: "12px",
                }}
              >
                {fact.description}
              </Typography>
            </div>

            <div
              style={{
                width: "80%",
                textAlign: "center",
                margin: "0px auto",
                marginTop: "18px",
              }}
            >
              <Button
                variant="contained"
                style={{
                  padding: "3px 30px",
                  borderRadius: "20px",
                  fontSize: "16px",
                  fontFamily: fontsName.VazirBold,
                  color: "#fff",
                  backgroundColor: "#4834d4",
                }}
                onClick={onClose}
              >
                بستن
              </Button>
            </div>
          </div>
        </Paper>
      </Modal>
    </>
  );
};

export default FeatureModal;
